// extracted by mini-css-extract-plugin
export default {"parent":"Updates_parent__kGU00","main":"Updates_main__7K6fH","input":"Updates_input__JAFWM"};